import React, { Component } from "react";
import Props from "./Props";

class FlexWrap extends Component {
  state = {
    property: "flex-wrap",
    definition:
      "The CSS flex-wrap property is used to specify whether flex items are forced into a single line or wrapped onto multiple lines. The flex-wrap property allows enabling the control direction in which lines are stacked. It is used to designate a single line or multi-line format to flex items inside the flex container.",
    defaultOption: "nowrap",
    options: ["nowrap", "wrap", "wrap-reverse"],
    flexContainer: { fcHeight: "220px", fcWidth: "600px" },
    flexItems: [
      { label: 1 },
      { label: 2 },
      { label: 3 },
      { label: 4 },
      { label: 5 },
      { label: 6 },
      { label: 7 },
      { label: 8 },
    ],
  };

  render() {
    const { state } = this;

    return <Props {...state} />;
  }
}

export default FlexWrap;
